import { ApiConfig } from '@/config/api.config';
import axios from 'axios';
import type { UseQueryOptions } from '@tanstack/react-query';
import { HEALTH_CHECK_INTERVAL_MS } from './constants';

export const healthCheckQueryKey = [
    'health-check',
    ApiConfig.healthCheckUrl ?? 'health-check-url-missing',
] as const;

export const isHealthCheckOk = (status: number | undefined): boolean => status === 200;

export const fetchHealthCheckStatus = async (): Promise<number> => {
    const healthCheckUrl = ApiConfig.healthCheckUrl;

    if (!healthCheckUrl) {
        throw new Error('Health check URL is not configured');
    }

    try {
        const response = await axios.get(healthCheckUrl, {
            validateStatus: () => true,
            timeout: 10_000,
        });
        return response.status;
    } catch {
        return 0;
    }
};

export const hasHealthCheckUrl = () => Boolean(ApiConfig.healthCheckUrl);

export const getHealthCheckQueryOptions = (options?: {
    enabled?: boolean;
    refetchInterval?: number;
}): UseQueryOptions<number, Error, number, typeof healthCheckQueryKey> => {
    const enabled = (options?.enabled ?? true) && hasHealthCheckUrl();
    const refetchInterval = enabled
        ? options?.refetchInterval ?? HEALTH_CHECK_INTERVAL_MS
        : false;

    return {
        queryKey: healthCheckQueryKey,
        queryFn: fetchHealthCheckStatus,
        enabled,
        retry: false,
        staleTime: 0,
        refetchOnMount: true,
        refetchInterval,
        refetchIntervalInBackground: true,
    };
};
